module.exports = __webpack_public_path__ + "img/model_300.acb06ad1.jpg";